module.exports = __webpack_public_path__ + "static/media/居民住宅一体化供暖4.d2e76051.jpg";